import { useCallback, useEffect, useRef, useState } from 'react';

import isFunction from 'utils/function';
import { isPhone } from 'utils/responsiveness';

import { onBeforeShowPlayerModal } from '../utils';

type Params = {
    handleCreateStreamSession?: () => void;
};

const useContentRatingOverlay = ({ handleCreateStreamSession }: Params) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const [showContentRatingOverlay, setShowContentRatingOverlay] =
        useState(false);

    const onCloseContentRatingOverlay = useCallback(() => {
        setShowContentRatingOverlay(false);

        if (isFunction(handleCreateStreamSession)) {
            handleCreateStreamSession();
        }
    }, [handleCreateStreamSession]);

    const onShowContentRatingOverlay = useCallback(() => {
        if (isPhone) {
            onBeforeShowPlayerModal();
            setShowContentRatingOverlay(true);
        } else {
            setShowContentRatingOverlay(true);
        }
    }, []);

    useEffect(() => {
        if (showContentRatingOverlay) {
            timeoutRef.current = setTimeout(() => {
                onCloseContentRatingOverlay();
            }, 3000);
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [showContentRatingOverlay]);

    return {
        showContentRatingOverlay,
        onShowContentRatingOverlay,
    };
};

export default useContentRatingOverlay;
